import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ConfigureGithubPage from './ConfigureGithubPage';

type GithubOnboardingStatus = {
    skipOnboarding?: boolean;
    hasCredentials?: boolean;
};

export default function LandingPage() {
    const navigate = useNavigate();
    const [shouldShowOnboarding, setShouldShowOnboarding] = useState<boolean | null>(null);

    useEffect(() => {
        let cancelled = false;

        async function loadGithubStatus() {
            try {
                const resp = await fetch(`/api/github/creds`);
                if (!resp.ok) {
                    throw new Error(await resp.text());
                }
                const data: GithubOnboardingStatus = await resp.json();
                const skipOnboarding = data?.skipOnboarding === true || data?.hasCredentials === true;

                if (cancelled) {
                    return;
                }

                if (skipOnboarding) {
                    setShouldShowOnboarding(false);
                    navigate('/tasks/new', { replace: true });
                } else {
                    setShouldShowOnboarding(true);
                }
            } catch (err) {
                console.error('Failed to load github onboarding status', err);
                if (!cancelled) {
                    setShouldShowOnboarding(true);
                }
            }
        }

        loadGithubStatus();

        return () => {
            cancelled = true;
        };
    }, [navigate]);

    if (shouldShowOnboarding === null) {
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <span>Loading...</span>
            </div>
        );
    }

    if (!shouldShowOnboarding) {
        return null;
    }

    return <ConfigureGithubPage />;
}
